import { useMinuteTick } from "../../hooks/useMinuteTick.js";
import { answerClockNeeded, answerClockStartsAt } from "../../lib/forecast/answerCheck.js";
import { useDeadlineClock } from "./useDeadlineClock.js";

/**
 * Keeps the page's clock moving for the active forecast while it sits idle: a re-render when the
 * day before its close starts, then one a minute through the close (which turns the answer box
 * and the trace cap on) and while the closed question waits ("Last checked …" ages). Off with
 * Forecast Tracking off, and under the debug today, which stays where it was set.
 *
 * @param {{active: object|null, forecastTracking: boolean, mockToday: string|null, nowMs: number}} args
 * @returns {boolean} whether the minute tick is running
 */
export function useAnswerClock({ active, forecastTracking, mockToday, nowMs }) {
  const on = !mockToday && !!forecastTracking;
  const woke = useDeadlineClock(on ? answerClockStartsAt(active) : null);
  const ticking = on && answerClockNeeded(active, Math.max(nowMs, woke));
  useMinuteTick(ticking);
  return ticking;
}
